module.exports = __webpack_public_path__ + "static/Blizzard_Entertainment_Logo-77b2a08b1552d9c2bf6b35af2f0a3063.svg";